import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import React from 'react';
import { dateItemFormatting } from '../Shared/Helpers/dateTimeHelper';
import { withTranslation } from 'react-i18next';

/***Component***/
const OfferCardGridItemComponent = ({ item, lang, t }) => {
  //if current date > start date  show item and less then end date
  //if current date < start date skip the item
  //if the end date < current skip
  //if no end date its an unlimited offer

  if (!item || !item?.fields) return null;
  const card = item?.fields;
  const image = card?.offerImage || card?.offerImage.value;
  const shouldRenderImage = !!image;
  const shouldRenderTitle = !!card?.merchantName;
  const shouldRenderDescription = !!card?.offerHighlight?.value;

  const locations = card?.locations?.targetItems || card?.locations;
  const shouldRenderLocation = !!locations.length > 0;

  //translation
  const txt_location = t('Location');
  let itemUrl = item?.fields?.url || item?.url;
  //get the last date of this month

  // If Validity End 30/12/2022= 30 December 2022
  // If Validity End 31/12/2022= Year of 2022
  // If Validity End 31/1/2023= Jan 2023
  // In in 2022 / 31/12/2023=Year 2023

  // or No Validity End= Year of 2022 ==> current year
  // or No Validity Start+ No Validity End= Year of 2022 ==> current year

  return (
    <a href={itemUrl} className="offer-card-grid-item">
      <div className="ocgi-header">
        {shouldRenderImage && (
          <div className="image-overflow">
            <Image field={image} />
          </div>
        )}
      </div>
      <div className="ocgi-data">
        <div className="ocgi-data-wrap">
          {shouldRenderTitle && (
            <div className="title">
              <div className="auto">
                <RichText className="onlineRichtext" field={card?.merchantName} />
              </div>
            </div>
          )}
          {shouldRenderDescription && (
            <div className="description flex-it flex-align-item-center">
              <div className="auto">
                <span className="icon flex-it flex-align-item-center flex-justify-center">
                  <img src={`/-/jssmedia/Project/FAB2/shared/images/ico-division.svg`} />
                </span>
                <span className="max-lines-four">
                  <RichText field={card.offerHighlight} />
                </span>
              </div>
            </div>
          )}

          <div className="icon-text timeFrame">
            <span className="icon">
              <img src={`/-/jssmedia/Project/FAB2/shared/images/icon-clock.svg`} />
            </span>

            <span>
              {dateItemFormatting(
                card?.validityStart?.value,
                card?.validityEnd?.value,
                lang,
                'm d y',
                t('yearOf')
              )}
            </span>
          </div>

          {shouldRenderLocation && (
            <div className="icon-text location">
              <span className="icon">
                <img src={`/-/jssmedia/Project/FAB2/shared/images/icon-location.svg`} />
              </span>
              <span>
                {/* shouBeFixedLangImp: this should be fixed on language implementing because the plural and singular issues between arabic and english 
                as a solution i kept  the 's' for english only*/}
                {locations?.length} {txt_location}
                {lang === 'en' && locations?.length > 1 ? 's' : ''}
              </span>
            </div>
          )}
        </div>
      </div>
    </a>
  );
};
//nonExpiringOffer
export default withTranslation()(OfferCardGridItemComponent);
